import CTA from 'components/Campaign/CTA';

import { DATA_TYPES } from 'siteconfig';

const EmptyResults = ({ type = DATA_TYPES.DRIVE }) => {
  let keyword;
  let noun;
  let copy;

  switch (type) {
    case DATA_TYPES.PETITION:
      keyword = 'write';
      noun = 'petitions';
      copy = 'Start a campaign';
      break;
    case DATA_TYPES.DRIVE:
      keyword = 'drive';
      noun = 'drives';
      copy = 'Start a drive';
      break;
    case DATA_TYPES.LETTER:
      keyword = 'write';
      noun = 'letters';
      copy = 'Write a letter';
      break;
    case DATA_TYPES.REVIEW:
      keyword = 'review';
      noun = 'reviews';
      copy = 'Review your official';
      break;
    default:
      keyword = 'drive';
      noun = 'drives';
      break;
  }

  const params = { keyword, copy };
  return (
    <div className="card-flat flex-col items-center gap-4 p-16">
      <p className="text-center">
        There are no {noun} here yet. Tap below to be the first!
      </p>
      <CTA {...params} />
    </div>
  );
};

export default EmptyResults;
